const typeMapping = [{ value: 0, label: '全部' }, { value: 1, label: '权限' }];

export default typeMapping;
